// removed by extract-text-webpack-plugin
module.exports = {"SecondOpinion__Card":"SecondOpinion__Card","secondOpinionCard":"SecondOpinion__Card","enter":"enter","SecondOpinion__StatusRow":"SecondOpinion__StatusRow","secondOpinionStatusRow":"SecondOpinion__StatusRow"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/moderation/second-opinion/SecondOpinion.scss
// module id = 574
// module chunks = 0